
export default function About() {
  return (
    <section id="about" className="py-32 px-8 lg:px-16">
      <div className="max-w-4xl mx-auto">
        <div className="mb-16">
          <div className="w-20 h-px bg-black mb-8"></div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-black mb-12 leading-tight">
            About SYG Yachts
          </h2>
        </div>
        
        <div className="space-y-8 text-lg md:text-xl leading-relaxed text-gray-800">
          <p>
            SYG Yachts is a boutique superyacht brokerage and advisory firm providing expert representation across yacht sales and acquisitions, charter, and comprehensive yacht services. Our approach is informed by the standards, market intelligence, and transactional rigor of the world's leading superyacht houses, combined with the focus and agility of a private advisory.
          </p>
          <p>
            We deliver senior-level involvement, strategic insight, and precision execution at every stage of ownership.
          </p>
        </div>
      </div>
    </section>
  );
}
